/**
 * This file is responsible for initializing services that are used across multiple microfrontends.
 * It is imported in bootstrap.tsx and should not contain any code that blocks the bootstrap process, such as awaiting promises.
 * Services that require asynchronous initialization should be initialized in a fire-and-forget manner, and should set any necessary global variables when resolved.
 */
import Sentry from "@similarweb/sentry-logger";

import { importWithRetry } from "./import-with-retry";
import { initEducation } from "./services/educationService";

export const initSharedServices = () => {
    initEducation();

    const serviceChunks: Array<() => Promise<unknown>> = [
        () => import("app/services/favorites/favoritesService"),
        () => import("app/services/recent/recentService"),
        () => import("app/services/preferences/preferencesService"),
        () => import("app/components/dashboard/services/DashboardService"),
    ];
    serviceChunks.forEach((importChunk) => {
        // Non-critical (see file header) — log and move on, don't burn the reload budget the
        // critical react-app chunk load (single-spa-config.ts) needs.
        importWithRetry(importChunk).catch((err) => {
            Sentry.errorTracker({
                message: "[bootstrap-service-init] chunk load failed",
                e: err,
                level: "error",
            });
        });
    });
};
